import type { ReactNode } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { roleAtLeast, type Role } from '@system-atlas/shared';
import { useTranslation } from 'react-i18next';
import { useAuth } from './AuthContext';
import { Spinner } from '../components/ui';

export function RequireAuth({ role, children }: { role?: Role; children: ReactNode }) {
  const { user, loading } = useAuth();
  const location = useLocation();
  const { t } = useTranslation();

  if (loading) return <Spinner />;
  if (!user) return <Navigate to="/login" replace />;
  if (user.mustChangePassword && location.pathname !== '/change-password') {
    return <Navigate to="/change-password" replace />;
  }
  // Erzwungene, aber noch nicht eingerichtete MFA: auf der Sicherheitsseite festnageln.
  if (user.mfaSetupRequired && location.pathname !== '/security') {
    return <Navigate to="/security" replace />;
  }
  if (role && !roleAtLeast(user.role, role)) {
    return <div className="p-10 text-center text-slate-600 dark:text-slate-300">{t('errors.forbidden')}</div>;
  }
  return <>{children}</>;
}
